let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fsiGA")).then(() => parcelRequire('9mEOd'));